/**
 * Selector de copias para imprimir QR (1 a 10)
 */

import { Minus, Plus } from 'lucide-react';

export const MAX_COPIES = 10;

interface QuantityStepperProps {
  value: number;
  onChange: (value: number) => void;
}

export function QuantityStepper({ value, onChange }: QuantityStepperProps) {
  return (
    <div
      role="group"
      aria-label="Copias"
      className="inline-flex shrink-0 items-center rounded-md border border-gray-300 bg-white"
    >
      <button
        type="button"
        onClick={() => onChange(Math.max(1, value - 1))}
        disabled={value <= 1}
        aria-label="Una copia menos"
        className="flex h-11 w-10 items-center justify-center text-content-primary disabled:text-gray-300"
      >
        <Minus className="h-4 w-4" />
      </button>
      <output aria-live="polite" className="min-w-6 text-center text-base font-medium tabular-nums">
        {value}
      </output>
      <button
        type="button"
        onClick={() => onChange(Math.min(MAX_COPIES, value + 1))}
        disabled={value >= MAX_COPIES}
        aria-label="Una copia más"
        className="flex h-11 w-10 items-center justify-center text-content-primary disabled:text-gray-300"
      >
        <Plus className="h-4 w-4" />
      </button>
    </div>
  );
}
